























































































































import loginMixin from '../mixin/loginMixin';
import SaveBtnGroup from '@/components/Common/SaveBtnGroup.vue';

import { IModifyPwd } from '@/interface/login';
import {
  gearModifyPwdApi,
  sendEmailCodeApi,
  getVerificationCodeApi,
} from '@/api/login';
import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';

@Component({
  components: {
    SaveBtnGroup
  }
})
export default class extends Mixins(loginMixin) {
  @Prop({ default: () => [] }) public phoneRegionOptions!: any;
  @Prop({ type: Boolean, default: 'false' }) public dialogVisible?: boolean;

  @Ref() public submitBtnRef!: any;
  @Ref() public modifyPwdFormRef!: any;

  get countDownNumStr() {
    return this.countDownNum + ' s';
  }

  get visible() {
    return this.dialogVisible;
  }
  set visible(newVal) {
    this.$emit('update:dialog-visible', newVal)
  }

  public form: IModifyPwd = {
    email: '',
    mobileAreaCode: '',
    mobile: '',
    verification: '',
    newLoginPs: '',
    confirmPs: '',
    loginId: '',
    fkPlatformType: 'get_issue',
  };
  public tab = 1;
  public countDownNum = 60;
  public countDownFlag = false;
  public countDownTimer: any = null;

  public rules = {
    email: [
      { required: true, message: this.$t('login.emailMsg'), trigger: 'blur' },
    ],
    verification: [
      { required: true, message: this.$t('login.verificationMsg'), trigger: 'blur' }
    ],
    newLoginPs: [
      { required: true, validator: this.validatePassword, trigger: 'blur'}
    ],
    confirmPs: [
      { validator: this.validateConfirmPs, trigger: 'blur' }
    ],
  };

  public validateConfirmPs(rule: any, value: string, callback: (err?: any) => void) {
    if (this.form.newLoginPs && this.form.newLoginPs !== value) {
      callback(new Error(this.$t('login.validPwdMsg') + ''));
    }
    callback();
  }

  // 获取验证码
  public async getVerification() {
    if (!this.checkEmpty()) {
      return;
    }
    let param: any = null;
    let api: any = null;
    if (this.tab === 1) {
      param = this.form.email;
      api = sendEmailCodeApi;
    } else {
      param = {
        type: 'forget',
        mobile: this.form.mobile,
        mobileAreaCode: this.form.mobileAreaCode,
      }
      api = getVerificationCodeApi;
    }
    const { data } = await api(param);
    if (data.code === '1003') {
      this.countDownFlag = true;
      this.setIntervalForVerify();
    }
  }

  public changeTab(tab: number) {
    this.tab = tab;
    clearInterval(this.countDownTimer);
    this.countDownFlag = false;
    this.countDownNum = 60;
  }

  // 验证码定时器 60s内不能重复获取
  public setIntervalForVerify() {
    this.countDownTimer = setInterval(() => {
      if (this.countDownNum === 1) {
        clearInterval(this.countDownTimer);
        this.countDownFlag = false;
        this.countDownNum = 60
        return;
      }
      this.countDownNum += -1;
    }, 1000);
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.countDownTimer);
    })
  }

  // 检查电话或区号是否为空
  public checkEmpty() {
    if (this.tab === 1 && !this.form.email) {
      this.$message(this.$t('login.emailMsg') as string);
      return false;
    } else if (this.tab === 2 && !this.form.mobile) {
      this.$message(this.$t('login.mobileMsg') as string);
    }
    return true;
  }

  public submit() {
    this.modifyPwdFormRef.validate((valid: boolean) => {
      if (valid) {
        // 如果是邮箱登录,则不传手机号
        if(this.tab === 1) {
          this.form.mobileAreaCode = ''
          this.form.mobile = ''
        }

        this.submitBtnRef.loadingTrue();
        this.form.loginId = this.form.email;
        gearModifyPwdApi(this.form).then(({ data }) => {
          if (data.code === '1003') {
            this.$message.success(this.$t('message.modifyPwdSuccess') as string);
            this.$emit('update:dialog-visible', false);
          }
        }).finally(() => {
          this.submitBtnRef.loadingFalse();
          this.clearForm();
        });
      }
    });
  }

  public cancel() {
    this.clearForm();
    this.$emit('update:dialog-visible', false);
  }

  public clearForm() {
    this.modifyPwdFormRef.resetFields();
  }
}
